/* eslint-disable no-console */
import { encode, decode } from '@atc/bonnet-seo';
export default class SeoParameter {
  constructor(key) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.brand = options.brand;
    this.multiParameters = undefined;
    this.encodedParam = undefined;
    this.encodedSlug = undefined;
    this.isMultiParameter = false;
    this.param = undefined;
    if (this.isSeoKey(key)) {
      this.param = this.decodeKey(key);
      this.encodedParam = this.encodeKey(this.param);
      this.encodedSlug = ':' + this.encodedParam;
      this.isMultiParameter = this.param.includes('_');
      this.multiParameters = this.param.split('_').filter(Boolean);
    } else {
      this.param = key;
      this.encodedParam = this.encodeKey(key);
      this.encodedSlug = ':' + this.encodedParam;
    }
  }
  encodeKey(key) {
    // prepend the seo key and then camel-case
    return `seo${key.charAt(0).toUpperCase()}${key.slice(1)}`;
  }
  async encodeValue(value, options) {
    return encode(value, {
      param: this.param,
      ...options
    });
  }
  decodeKey(key) {
    // remove
    // 1) any seo prefix
    // 2) any seo route parameter flags
    const _key = key.replace(/^(seo|:seo)/, '').replace(/[:/?]/g, '');
    // camel case the result to obtain the natural key
    return `${_key.charAt(0).toLowerCase()}${_key.slice(1)}`;
  }
  async decodeValue(value, options) {
    return decode(value, {
      param: this.param,
      ...options
    });
  }
  isSeoKey(key) {
    return Array.isArray(key.match(/^(seo|:seo)/));
  }
}